import { createI18n } from 'vue-i18n'
import zhCN from './locales/zh-CN.json'
import enUS from './locales/en-US.json'

const LOCALE_STORAGE_KEY = 'app-locale'

// 支持的语言列表
export const SUPPORTED_LOCALES = ['zh-CN', 'en-US'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

// 获取保存的语言偏好，若未保存则返回系统语言或默认中文
const getSavedLocale = (): SupportedLocale => {
  const saved = localStorage.getItem(LOCALE_STORAGE_KEY) as SupportedLocale | null
  if (saved && SUPPORTED_LOCALES.includes(saved)) {
    return saved
  }

  // 尝试从浏览器语言推导
  const browserLang = navigator.language
  if (browserLang.startsWith('en')) {
    return 'en-US'
  }

  return 'zh-CN'
}

const i18n = createI18n({
  legacy: false,
  locale: getSavedLocale(),
  fallbackLocale: 'en-US',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
  },
  globalInjection: true,
  missingWarn: false,
  fallbackWarn: false,
})

// 设置语言并持久化
export const setLocale = (locale: SupportedLocale): void => {
  if (!SUPPORTED_LOCALES.includes(locale)) {
    console.warn(`Unsupported locale: ${locale}`)
    return
  }

  i18n.global.locale.value = locale
  localStorage.setItem(LOCALE_STORAGE_KEY, locale)
}

// 获取当前语言
export const getLocale = (): SupportedLocale => (i18n.global.locale.value || 'zh-CN') as SupportedLocale
export const t = i18n.global.t
export const isEnUS = (): boolean => getLocale() === 'en-US'
export const isZhCN = (): boolean => getLocale() === 'zh-CN'
export const applyLocaleMessages = (messages: Record<SupportedLocale, string>): string => {
  const locale = getLocale()
  return messages[locale] || messages['en-US']
}

export default i18n